<!-- 学员详情-沟通记录 -->
<template>
  <div class="intention-item-box">
      <div class="title" v-if="list.length">
        <div class="left">
        </div>
        <div class="right" v-if="app.permission.op('add_student_communicate')" @click="$emit('add')">
          <span class="add-communicate" >
            <van-icon name="plus" ></van-icon>添加
          </span>
        </div>
      </div>   
    <div
      class="intention-communicate-item"
      v-for="item in list"
      :key="item.id"
    >
      <div 
        class="circular-point">
      </div>
      <div class="title">
        {{ app.tool.date.getPassTimeStr(item.createTime)}}
      </div>
      <div class="log-item">
        <div class="types-line">
          添加沟通记录<span style="color:var(--g6);" v-if="item.teacherName">({{item.teacherName}})</span>
        </div>
        <div 
          class="log-content communicate-item" 
          @click="toDetailsCommunicateInfos(item)"
          >
          <div class="content-nav">
            <div class="content"  >
              <vx-mult-input-intro
                @click="toDetailsCommunicateInfos(item)"
                class="r"
                v-if="item.content.list"
                :list="item.content.list"
              />
              <van-popover
                class="communicate-popover"
                v-model="item.showPopover"
                trigger="click"
                placement="bottom-end"
                v-if="app.permission.op('edit_student_communicate || delete_student_communicate')"
                :offset="[22, 4]"
                :get-container="()=>$el"
              >
                <div 
                  @click.stop="gotoEditCommunicate(item)"
                  v-if="app.permission.op('edit_student_communicate')"
                  class="communicate-popover popover-item">
                  编辑
                </div>
                <div 
                  class="communicate-popover popover-item"
                  @click.stop="deleteCommunication(item)"
                  v-if="app.permission.op('delete_student_communicate')"
                  :class="{'van-hairline--top': true}"
                  style="color:var(--c3)">
                  删除
                </div>
                <template #reference>
                  <van-icon name="weapp-nav" class="operation-icon" @click.stop="$set(item,'showPopover',true)" />
                </template>
              </van-popover>
            </div>
            <div class="con" >
              <span 
                v-if="  item.typeDesc"
                class="tag primary" >
                {{  item.typeDesc }}
              </span>
              <span 
                v-if=" item.mode"
                class="tag primary" >
                {{  item.mode }}
              </span>
            </div>
          </div>
        </div>
        <div 
          class="types-line van-ellipsis" 
          style="margin:calc(var(--gap) * -24)  0 calc(var(--gap) * 26) 0;" 
          v-if="item.intentionClueId">
          来自意向：
          <span style="color:var(--c1);" @click="$router.push('/cluedetails?id='+item.intentionClueId)">
            {{item.intentionClueContent}}
          </span>
        </div>
      </div>
    </div>
    <van-empty
      image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
      description="当前还没有沟通记录"
      v-if="!list || (list && list.length == 0)"
      image-size="128"
    >
    <van-button
      square round
      type="primary"
      class="add-btns"
      v-if="app.permission.op('add_student_communicate')"
      @click="$emit('add')"
    >
      添加沟通记录
    </van-button>
    </van-empty>
  </div>
</template>
<script>
export default {
  name: "intention-communicate",
  props: {
    list: {
      type: Array,
      default: function () {
        return [];
      },
    },
    fromPage: {
      type: String,
      default: 'clue'
    }
  },
  data (){ 
    return {
      showPopover: true,
    }
  },
  methods: {
    toDetailsCommunicateInfos(item) {
      let path = '/communicationDetails?';
      path += `detailId=${item.id}`
      this.$router.push(path);
    },
    gotoEditCommunicate(item) {
      item.showPopover = false;
      if (app.permission.op('edit_student_communicate')) {
        let path = '/addStudentCommunication?';
        path += `&detailId=${item.id}`    
        this.$router.push(path);
      }
    },
    deleteCommunication(item) {
      item.showPopover = false;
      this.$dialog
        .confirm({
          message: "确定要删除此条沟通记录么？",
        })
        .then(() => {
          this.$api
            .deleteIntentionCommunicate({
              id: item.id,
            })
            .then((res) => {
              if (res.code === 200) {
                this.$toast.success("操作成功");
                this.fromPage === 'clue' 
                ? app.vue.$emit("refresh-communicate-list") 
                : app.vue.$emit("refresh-student-communicate-list") ;
              }
            });
        })
        .catch(() => {});
    },
  }
};
</script>
<style lang="scss" scoped>
.intention-item-box {
  position: relative;
  margin: calc(var(--gap) * 8) calc(var(--gap) * 16);
  padding: calc(var(--gap) * 8) calc(var(--gap) * 16) calc(var(--gap) * 16) calc(var(--gap) * 21);
  border-radius: calc(var(--gap) * 8);
  background-color: var(--white);
  .add-area{
    margin-bottom: calc(var(--gap) * 6);
    background-color: transparent;
    justify-content: flex-end;
  }
  >.title{
    display: flex;
    min-height: calc(var(--w) * 48);
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
    font-weight: var(--bold);
    justify-content: space-between;
    align-items: center;
    .left{
      flex: 1;
    }
    .right{
      flex-shrink: 0;
      white-space: nowrap;

      .icon {
        width: 24px;
        height: 24px;
        &:last-child{
          margin-left: calc(var(--gap) * 24);
        }
      }
    }

    ::v-deep .van-rate>div{
      padding: 0;
      margin-right: calc(var(--gap) * 12);
    }
  }
  .intention-communicate-item {
    position: relative;
    padding: 0 0 0 calc(var(--gap) * 16);
    border: 1px solid transparent;
    color: var(--g6);

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: calc(var(--w) * 24);
      bottom: 0;
      width: 1px;
      background-color: var(--g4);
    }

    &:last-child{
      &::before{
        display: none;
      }
      .circular-point{        
        background-color: var(--g4);
      }
    }
    .circular-point {
      position: absolute;
      top: calc(var(--gap) * 4);
      left: 0;
      width: calc(var(--w) * 10);
      height: calc(var(--w) * 10);
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: var(--c1);
      transform: translate(-50%, 0);
      border-radius: 50%;
      >i{
        font-size:var(--fs-sm);
        color: var(--white);
        transform: scale(0.9);
      }
      &.active{        
        background-color: var(--c4);
      }
      &.audition{
        background-color: var(--c2);
      }
    }
    .title {
      //   margin: 0 0 calc(var(--gap) * 8);
      margin-bottom: calc(var(--gap) * 8);
      margin-left: calc(var(--gap) * 4);
      font-size: var(--fs-sm);
      line-height: var(--lh-sm);
      .next-class {
        padding-left: calc(var(--gap) * 4);
        color: var(--c1);
      }
    }
    &:first-child{
      margin-top: calc(var(--gap) * 12);
    }
  }
  .title + .intention-communicate-item {
    &:last-child{
      &::before{
        display: block;
      }
      .circular-point{        
        background-color: var(--c1);
      }
    }
  }
  .add-communicate{
    display: flex;
    align-items: center;
    padding: calc(var(--gap) * 4) calc(var(--gap) * 8);
    border-radius: 16px;
    border: 1px solid #CCCCCC;
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
  }
  .log-item{
    margin: calc(var(--gap) * 16) 0;
    .types-line{
      color: var(--g8);
    }
    .log-content {
      margin: calc(var(--gap) * 4) 0 calc(var(--gap) * 28);
      padding: calc(var(--gap) * 12);
      border-radius: var(--radius-sm);
      background-color: rgba(var(--c1-rgb), 0.08);
      .line{
        display: flex;
        .content{
          flex: 1;
        }
        .label{
          white-space: nowrap;
          flex-shrink: 0;
        }
      }
    }
    .communicate-item{
      .content-nav .content{
        display: flex;
        >div{
          padding: 0;
          flex: 1;
        }
        i{
          font-size: var(--fs-lg);
          line-height: var(--lh-lg);
        }
        
        ::v-deep div.text{
          font-size:var(--fs-md);
          line-height:var(--lh-md);
        }
      }
    }
    .con {
      margin-top: calc(var(--gap) * 8);
      &:first-child {
        margin-top: 0;
      }
      .point {
        color: var(--g8);
      }
 
    }
    .tag {
      padding: 0 calc(var(--gap) * 4);
      display: inline-block;
      color: var(--g5);
      font-size:var(--fs-sm);
      
      color: var(--c1);
      border-radius: 2px;
      border: 1px solid var(--c1);
      &:not(:last-child){
        margin-right: calc(var(--gap) * 8);
      }
    }
  }
  .communicate-popover{
    
    height: calc(var(--w) * 18);
    &.popover-item{
      margin: 0 calc(var(--gap) * 12);
      width: calc(var(--w) * 96);
      height: calc(var(--w) * 44);
      font-size:var(--fs-md);
      font-weight: 400;
      line-height: 44px;
      text-align: center;
      color: var(--g8);
      cursor: pointer;
    }
  }
}

.line {
  padding: calc(var(--gap) * 4) 0;
  display: flex;
  .r {
    flex: 1;
    ::v-deep &.mult-input-intro {
      padding: 0;
      .text {
        color: var(--g7);
      }
    }
  }
}
</style>